import React from "react";
import { InputSearch } from "../../../../../../boxes/InputSearch/InputSearch";
import styles from "./styles.module.scss";

export function Header({ search }) {
  return (
    <div className={styles.root}>
      <InputSearch value={search.value} onChange={search.update} />
    </div>
  );
}
